<template>
  <b-form-group
    :id="id"
    :label="label"
    class="label"
    :label-class="{ label_legend: true, 'text-required': required }"
  >
    <b-input-group :state="state">
      <the-mask
        ref="imputMask"
        v-model="content"
        class="form-control"
        v-bind:class="{
          'is-valid': state,
          'is-invalid': state == false,
          'input-autenticacao': authStyle,
        }"
        trim
        :placeholder="placeholder"
        masked
        @input="handleInput"
        :mask="mask"
        @change.native="change"
      />
      <slot name="append"></slot>
    </b-input-group>
    <b-form-invalid-feedback :state="state">{{ feedback }}</b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
import helpers from "@/common/utils/helpers";
export default {
  name: "InputMask",
  props: {
    id: { type: String },
    value: { type: String || Number, default: "" },
    label: { type: String, required: true },
    inputClass: { type: String },
    placeholder: { type: String },
    authStyle: { type: Boolean },
    mask: { required: true },
    upper: { type: Boolean },
    required: { type: Boolean },
    requiredMessage: { type: String },
    length: { type: Number, default: 0 },
    lengthMessage: { type: String },
    cpfMessage: { type: String },
    invalidEmailMessage: { type: String },
    validate: { type: Boolean, default: null },
    minLength: { type: Number, default: null },
    type: { type: String },
  },
  data() {
    return {
      content: this.value,
      validForm: false,
      hasError: false,
      errorMessage: "",
    };
  },
  computed: {
    requiredValid() {
      return !(this.required && !this.content);
    },
    lengthValid() {
      return !(this.length > 0 && this.content?.length != this.length);
    },
    state() {
      // Erro vindo do backend (showError) marca o campo como inválido antes de
      // qualquer outra regra: sem isto algumas regras devolviam true/null antes
      // de olhar o hasError e o campo culpado nunca ficava vermelho.
      if (this.hasError) return false;

      if (!this.validForm) return null;

      return this.validacoes();
    },
    minLengthValid() {
      return !(this.minLength > 0 && this.content
        ? this.content.length
        : 0 < this.minLength);
    },
    feedback() {
      // A mensagem que o backend mandou para ESTE campo vence a validação
      // genérica do cliente: ela é mais específica e foi o servidor que recusou.
      if (this.hasError) return this.errorMessage;

      if (!this.requiredValid)
        return (
          this.requiredMessage ||
          this.$t("CAMPOS_VALIDACAO.REQUERIDO").formatUnicorn({
            name: this.label,
          })
        );
      if (!this.lengthValid)
        return (
          this.lengthMessage ||
          this.$t("CAMPOS_VALIDACAO.TAMANHO").formatUnicorn({
            name: this.label,
            length: this.length,
          })
        );

      if (this.validate != null && !this.validate)
        return (
          this.invalidEmailMessage ||
          this.$t("CAMPOS_VALIDACAO.INVALIDO").formatUnicorn({
            name: this.label,
          })
        );
      if (!this.minLengthValid)
        return (
          this.minLengthMessage ||
          this.$t("CAMPOS_VALIDACAO.COMPRIMENTO_MINIMO").formatUnicorn({
            name: this.label,
            length: this.minLength,
          })
        );
      if (this.content && this.type == "cpf" && !this.validarDocumento())
        return (
          this.cpfMessage ||
          this.$t("CAMPOS_VALIDACAO.CPF_INVALIDO").formatUnicorn({
            name: this.label,
          })
        );
      if (this.content && this.type == "cpf_cnpj" && !this.validarDocumento())
        return (
          this.cpfMessage ||
          this.$t("CAMPOS_VALIDACAO.CPF_CNPJ_INVALIDO").formatUnicorn({
            name: this.label,
          })
        );
      return "";
    },
  },
  methods: {
    showError(message) {
      this.validForm = true;
      this.hasError = true;
      this.errorMessage = message;
    },
    handleInput() {
      if (this.upper && this.content) this.content = this.content.toUpperCase();
      this.$emit("input", this.content);
      this.hasError = false;
    },
    validacoes() {
      if (!this.minLengthValid) return false;
      if (!this.requiredValid) return false;
      if (!this.lengthValid) return false;
      if (this.content && (this.type == "cpf" || this.type == "cpf_cnpj"))
        return this.validarDocumento();
      if (this.hasError) return false;
      if (this.validate != null) return this.validate;

      return true;
    },
    valid(validacaoEscondida = false) {
      if (validacaoEscondida) {
        return this.validacoes();
      }
      this.validForm = true;
      return this.state;
    },
    clear() {
      this.content = "";
      this.validForm = false;
      this.$emit("input", this.content);
    },
    change() {
      this.$emit("change", this.content);
    },
    validarDocumento() {
      return helpers.validarCpfCnpj(this.content);
    },
  },
  watch: {
    value: {
      handler(value) {
        this.content = value;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style>
.label {
  overflow: hidden;
}

.label_legend {
  white-space: nowrap;
}
</style>
